import React, { useEffect, useState } from "react";
import axios from "axios";

const ContractorToolsView = ({ profile }) => {
    const [toolsData, setToolsData] = useState([]);
    const [selectedTools, setSelectedTools] = useState(new Set());

    useEffect(() => {
        axios
            .get("/api/users/fetch_tools_detail")
            .then((res) => setToolsData(res.data.tools || []))
            .catch((err) => console.error("Error loading tools:", err));
    }, []);

    useEffect(() => {
        if (profile?.tools?.length) {
            setSelectedTools(new Set(profile.tools.map((item) => item.toolss)));
        }
    }, [profile]);

    const itemsRowStyle = { display: "flex", alignItems: "flex-start", gap: "10px" };
    const labelStyle = { width: "200px", fontWeight: 600, flexShrink: 0 };
    const textStyle = { flex: 1 };

    return (
        <div className="toolbox_container">
            {/* === Minimum Toolbox === */}
            <div className="toolbox_section">
                <div className="toolbox_header">
                    <h3 className="toolbox_title">Minimum Toolbox</h3>
                </div>

                <div className="toolbox_items" style={itemsRowStyle}>
                    <div className="item_label" style={labelStyle}>Standard Toolbox Items:</div>
                    <div className="item_text" style={textStyle}>
                        66/110 punch down tool, buttset, RJ45 crimpers, cable tester, 8'
                        ladder, zip ties, velcro, smart phone, Toner, fish tape, hammer
                        drill, Cordless Drill, PTouch Labeler or similar
                    </div>
                </div>

                <div className="toolbox_items" style={itemsRowStyle}>
                    <div className="item_label" style={labelStyle}>Standard Materials:</div>
                    <div className="item_text" style={textStyle}>
                        Patch cables, Cat5 cable, RJ45 connectors, button clips, 3M gel connectors
                    </div>
                </div>

                {/* === Toolbox Categories === */}
                <div className="toolbox_categories">
                    {toolsData.map((tool) => (
                        <button
                            key={tool.title}
                            type="button"
                            className={`toolbox_category ${selectedTools.has(tool.title) ? "active" : ""}`}
                        >
                            {tool.title}
                        </button>
                    ))}
                </div>
                <br/>

                {/* === Dynamic Toolbox Details === */}
                {toolsData.map((tool) => (
                    <div className="toolbox_detail_section" key={tool.title}>
                        <h3 className="toolbox_title">{tool.title}</h3>

                        <div className="toolbox_items" style={itemsRowStyle}>
                            <div className="item_label" style={labelStyle}>Standard Toolbox Items:</div>
                            <div className="item_text" style={textStyle}>{tool.tools.join(", ")}</div>
                        </div>

                        <div className="toolbox_items" style={itemsRowStyle}>
                            <div className="item_label" style={labelStyle}>Standard Materials:</div>
                            <div className="item_text" style={textStyle}>{tool.materials.join(", ")}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ContractorToolsView;
